<div class="backround">
    <div class="menu">
        <div class="section-1 animate__animated animate__slideInDown">
            <p class="windowswap-text" [routerLink]="['/']">WindowSwap</p>
        </div>
        <div class="section-2">
            <ul>
                <li [ngClass]="{ active: editProfile }" (click)="editprofile()">Edit profile</li>
                <li [ngClass]="{ active: changePassword }" (click)="changepassword()">Change Password</li>
                <li *ngIf="prime && subscriptionId" [ngClass]="{ active: allAccess }" (click)="allaccess()">
                    All-Access</li>
                <li [ngClass]="{ active: closeAccount }" (click)="closeaccount()">Close Account</li>
            </ul>
        </div>
        <div class="section-3">
            <p>
                Questions? Email us at <br><a href="mailto:{{ emailAddress }}"
                    target="_blank"><b>{{ emailAddress }}</b></a>
            </p>
        </div>
    </div>
    <div class="container">
        <div class="user-menu animate__animated animate__slideInDown">
          <app-user-menu [from]="from" class="user-menu-comp"></app-user-menu>       
        </div>
        <div class="render">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
<div class="mobile-background" [ngStyle]="{ height: windowWidth }">
    <div class="mobile-heading">
        <div class="mobile-section1">
            <!-- <app-user-menu [from]="from" [isMobile]="isMobile" *ngIf="!editProfileMobile"></app-user-menu> -->
            <!-- <img (click)="toMenu()" class="back-img" *ngIf="editProfileMobile" src="{{constants.BACK_BUTTON_BOOKMARK}}"> -->
        </div>
        <div class="mobile-section2">
            <p class="windowswap-text" [routerLink]="['/']">WindowSwap</p>
        </div>
        <div class="mobile-section3">
            <!-- <img  src="{{constants.MOBILE_MENU}}"> -->
            <!-- <app-user-menu [from]="from"></app-user-menu> -->
            <app-user-menu [from]="from" [isMobile]="isMobile" *ngIf="!editProfileMobile"></app-user-menu>
        </div>
    </div>

    <div class="menu-mobile" *ngIf="!editProfileMobile">
        <p class="menu-heading-mobile">Settings</p>
        <hr class="underline">
        <div class="menu-item-mobile">
            <ul>
                <li (click)="editprofile()">Edit Profile</li>
                <li (click)="changepassword()">Change Password</li>
                <li *ngIf="prime && subscriptionId" (click)="allaccess()">All-Access</li>
                <li (click)="closeaccount()">Close Account</li>
            </ul>
        </div>
    </div>
    <div class="container" *ngIf="editProfileMobile">
        <router-outlet></router-outlet>
    </div>
    <div [ngClass]="{ 'help-mobile': !editProfileMobile , 'help-mobile-1': editProfileMobile}">
        <p>
            Questions? Email us at <a href="mailto:{{ emailAddress }}"
                target="_blank"><b>{{ emailAddress }}</b></a>
        </p>
    </div>
</div>